let filterInstances;

const TERM_SEPARATOR = '|||';

const append = (setA, setB) => {
	for (const elem of setB) {
		setA.add(elem);
	}
	return setA;
};

const getTermStatus = (venueTermSet, term) => venueTermSet.has(term);

const parseSerializedTermArray = (venueTermsStr) =>
	!venueTermsStr?.length
		? []
		: venueTermsStr
				.substring(
					TERM_SEPARATOR.length,
					venueTermsStr.length - TERM_SEPARATOR.length
				)
				.split(TERM_SEPARATOR);

const doFilter = (query) => {
	const visibilityByFilter = Object.keys(query).reduce(
		(orderedFilterResults, key) => {
			const term = query[key];
			orderedFilterResults.push(filterInstances[key].filter(term));
			return orderedFilterResults;
		},
		[]
	);
	return visibilityByFilter[0].map((_, index) => {
		return visibilityByFilter.reduce(
			(isVisible, filterResults) => isVisible && filterResults[index],
			true
		);
	});
};

class VenueFilter {
	constructor(filterData, options = {}) {
		this._hasMultipleTerms = options.hasMultipleTerms;
		const normalizedData = this.constructor.normalizeData(
			filterData,
			this._hasMultipleTerms
		);
		this._processData(normalizedData);
		this._processTerms();
	}

	_processData(normalizedData) {
		this._data = normalizedData.map((terms) => new Set(terms));
	}

	_processTerms() {
		const collator = new Intl.Collator('en-US');
		const termSet = this._data.reduce(
			(allTerms, venueTermSet) => append(allTerms, venueTermSet),
			new Set()
		);
		this._terms = Array.from(termSet.values()).sort(collator.compare);
	}

	get terms() {
		return this._terms;
	}

	filter(term) {
		if (!term) return this._data.map(() => true);
		return this._data.map((venueData) => getTermStatus(venueData, term));
	}

	static normalizeData = (filterData, multiple) =>
		filterData.map((venueTermsStr) =>
			multiple
				? parseSerializedTermArray(venueTermsStr)
				: [venueTermsStr].filter((a) => a)
		);
}

onmessage = (event) => {
	const filterEvent = event.data;
	switch (filterEvent.type) {
		case 'INIT':
			filterInstances = Object.keys(filterEvent.payload).reduce(
				(instances, key) => {
					const hasMultipleTerms = key === 'venueEventStyles';
					instances[key] = new VenueFilter(filterEvent.payload[key], {
						hasMultipleTerms,
					});
					return instances;
				},
				{}
			);
			postMessage({
				type: 'READY',
				payload: Object.keys(filterInstances).reduce(
					(instances, key) => {
						instances[key] = filterInstances[key].terms;
						return instances;
					},
					{}
				),
			});
			break;
		case 'FILTER':
			postMessage({
				type: 'FILTER_RESULTS',
				payload: doFilter(filterEvent.payload),
			});
			break;
		default:
			// eslint-disable-next-line no-console
			console.warn(`Received unrecognized message ${filterEvent.type}`);
	}
};
